import React, { useMemo, useState, useEffect } from 'react';
import classNames from 'classnames';
import { Route, Switch, useRouteMatch, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { IRootState } from 'store';
import _ from 'lodash';
import SideBar from 'components/sideBar';
import ChooseMapTemplate from 'pages/chooseMap';
import CreateProfile from 'pages/createProfile';
import TimeTable from 'pages/timetable';
// import ReviewHome from 'pages/review-home';
import SwitchTemplate from 'pages/switchTemplate';
import Resources from 'pages/resources';
import SigninWithCreds from 'pages/signinWithCreds';
// import WhatsNextRoom from 'pages/whatsNextRoom/index';
import styles from './styles.module.scss';

const mapStateToProps = (state: IRootState) => ({
  units: state.scholars.units,
  activeScholarId: state.users.userData?.activeScholarId,
});
interface OnboardingProps extends ReturnType<typeof mapStateToProps> {
  hasChildren: boolean;
  userType: string;
}

const Onboarding: React.FC<OnboardingProps> = ({
  units,
  userType,
  activeScholarId,
}) => {
  const [kidName, setKidName] = useState('');
  const match = useRouteMatch();
  const location = useLocation();

  useEffect(() => {
    if (!_.isEmpty(units)) {
      const activeKid = _.find(units, (kid) => {
        return kid.id === activeScholarId;
      });
      if (activeKid) {
        setKidName(`${activeKid?.name}'s`);
      }
    }
  }, [units, activeScholarId]);

  const isMapTemplateVisible = useMemo(
    () =>
      !_.includes(
        [
          '/onboarding/choose-map/switch-template',
          '/onboarding/choose-map/review-map',
        ],
        location.pathname
      ),
    [location.pathname]
  );

  const isTimetableVisible = useMemo(
    () =>
      !_.includes(
        [
          '/onboarding/timetable/review-map',
          '/onboarding/timetable/resources',
          '/onboarding/timetable/review-home',
          '/onboarding/timetable/signin-with-credentials',
        ],
        location.pathname
      ),
    [location.pathname]
  );

  return (
    <main className={classNames('container', styles.root)}>
      <SideBar />
      {userType === 'parent' ? (
        <Switch>
          <Route key="choose-map" path={`${match.path}/choose-map`}>
            {isMapTemplateVisible && <ChooseMapTemplate />}
            <Route
              key="switch-template"
              path={`${match.path}/choose-map/switch-template`}
            >
              <SwitchTemplate />
            </Route>
          </Route>
          <Route key="setup-profile" path={`${match.path}/profile`}>
            <CreateProfile />
          </Route>
          <Route key="timetable" path={`${match.path}/timetable`}>
            {isTimetableVisible && <TimeTable kidName={kidName} />}
            <Route key="resources" path={`${match.path}/timetable/resources`}>
              <Resources kidName={kidName} />
            </Route>
            {/* <Route key="review-map" path={`${match.path}/timetable/review-map`}>
            <ReviewHome kidName={kidName} />
          </Route>
          <Route key="review-home" path={`${match.path}/timetable/review-home`}>
            <ReviewHome />
          </Route> */}
            <Route
              key="signin-with-credentials"
              path={`${match.path}/timetable/signin-with-credentials`}
            >
              <SigninWithCreds />
            </Route>
          </Route>
        </Switch>
      ) : (
        <Switch>
          <Route key="setup-profile" path={`${match.path}/profile`}>
            <CreateProfile />
          </Route>
          <Route key="timetable" path={`${match.path}/timetable`}>
            {isTimetableVisible && (
              <TimeTable kidName={kidName} role={userType} />
            )}
            <Route key="resources" path={`${match.path}/timetable/resources`}>
              <Resources kidName={kidName} />
            </Route>
          </Route>
        </Switch>
      )}
    </main>
  );
};

export default connect(mapStateToProps)(Onboarding);
